import LayoutAdmin from '../layout/LayoutAdmin';
import LayoutBasic from '../layout/LayoutBasic';

//Admin Pages
import AdminHome from '../pages/Admin';
import AdminBilling from '../pages/Admin/Billing';
import AdminPayment from '../pages/Admin/Payment';
import AdminClarifications from '../pages/Admin/Clarifications';
import AdminClarificationsDetail from '../pages/Admin/Clarifications/ClarificationsDetail';
import AdminAddClarifications from '../pages/Admin/Clarifications/AddClarificationPage';
import AdminAddClarificationPayment from '../pages/Admin/Clarifications/AddClarificationPaymentPage';
import AdminProfile from '../pages/Admin/Profile';
import AdminConfiguration from '../pages/Admin/Configuration';
import AdminCompanyData from '../pages/Admin/Configuration/CompanyData/CompanyData';
import AdminContact from '../pages/Admin/Configuration/ContactPage';
import AdminSeries from '../pages/Admin/Configuration/SeriesPage';
import Administration from '../pages/Admin/Administration';
import SuplierCatalog from '../pages/Admin/Administration/Suplier';
import SuppliersContacts from '../pages/Admin/SupplierPage/SupplierContactsPage';
import SuppliersContainerYard from '../pages/Admin/SupplierPage/SuppliersContainerYard';
import SupplierRoutes from '../pages/Admin/SupplierPage/SupplierRoutes';
import SuppliersAdditionalServices from '../pages/Admin/SupplierPage/SupplierAdditionalServicesPage';

import UsersCatalog from '../pages/Admin/Administration/Users';
import AlertsCatalog from '../pages/Admin/Administration/Alert';
import BilllingDocument from '../pages/Admin/Billing/Documents';
import AdminSuppliers from '../pages/Admin/SupplierPage';
import AdminFinancial from '../pages/Admin/SuppliersAdmin';
import AdminClientFinancial from '../pages/Admin/CustomersAdmin';

import AdminAddClarificationDocuments from '../pages/Admin/Clarifications/Documents/Documents';
import ClientsCatalog from '../pages/Admin/Administration/Clients';
import SuplierOperations from '../pages/Admin/SupplierPage/SupplierOperations';

//Page Clientes
import ClientBalance from '../pages/PortalCliente/Balance';
import CustomerBalance from '../pages/PortalCliente/CustomerBalance';
import ClientOperation from '../pages/PortalCliente/Operation';
import ClientOperationDetail from '../pages/PortalCliente/Operation/OperationDetailPage/OperationDetailPage';
import ClientOperationDocument from '../pages/PortalCliente/Operation/Documents/Documents';
import ClientBilling from '../pages/PortalCliente/Billing';
import Rentability from '../pages/Admin/Rentability';
import ClientClarifications from '../pages/PortalCliente/Clarifications';
import AdminCustomers from '../pages/PortalCliente/CustomersPage';
import CustomerClients from '../pages/PortalCliente/CustomersPage/CustomerContactsPage';
import RoutesClient from '../pages/PortalCliente/CustomersPage/CustomerRoutesPage';
import DocumentsClient from '../pages/PortalCliente/CustomersPage/CustomerDocumentsPage';

//Pages 2 Logistic
import Sales from '../pages/Logistic/Sales';
import Pricing from '../pages/Logistic/Pricing';
import RFQResponses from '../pages/Logistic/RFQ/RFQResponses';
import Traffic from '../pages/Logistic/Traffic';
import Quote from '../pages/Logistic/QuotePage';
import UnUsedQuotes from '../pages/Logistic/UnUsedQuotesPage';
import SupplierPromotion from '../pages/Logistic/SupplierPromotionPage';
import CustomerPromotion from '../pages/Logistic/CustomerPromotionPage';
import AddQuote from '../pages/Logistic/QuotePage/AddQuotePage';
import LinesQuote from '../pages/Logistic/QuotePage/LinesQuote';
import Catalog from '../pages/Admin/Catalog';
import Modules from '../pages/Admin//Catalog/Modules';
import ViewPdf from '../components/Logistic/Quote/QuotePdf/ViewPdf';
import Operation from '../pages/Logistic/OperationPage';
import AvailableUnits from '../pages/Logistic/AvailableUnits';
import CallLog from '../pages/Logistic/CallLogPage';
import OperationFinancial from '../pages/Logistic/OperationPage/OperationFinancial';
import AddOperation from '../pages/Logistic/OperationPage/AddOperationPage';
import OperationDocuments from '../pages/Logistic/OperationPage/OperationDocuments';
import Payments from '../pages/Logistic/Payments';
import CardsBilling from '../pages/Logistic/CardsBilling';
import PurchaseOrder from '../pages/Logistic/PurchaseOrder';

//Pages
import Login from '../pages/Login';

//other
import Error404 from '../pages/Error404';
import PasswordRecovery from '../pages/PasswordRecovery/PasswordRecovery';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import {
  ROL_ADMIN,
  ROL_MANAGER,
  ROL_OPERACIONES,
  ROL_SUPPLIER,
  ROL_TODOS,
  ROL_FINANCIAL,
  ROL_CUSTOMER,
  ROL_VENTAS,
  ROL_PRICING,
  ROL_LAYOUT,
} from '../utils/constants';

const routes = [
  {
    path: '/login',
    component: LayoutBasic,
    exact: false,
    routes: [
      {
        path: '/login',
        component: Login,
        exact: true,
      },
      {
        path: '/login/recuperar-contraseña',
        component: PasswordRecovery,
        exact: true,
      },
      {
        component: Error404,
      },
    ],
  },
  {
    path: '/Account',
    component: LayoutBasic,
    exact: false,
    routes: [
      {
        path: '/Account/ResetPassword',
        component: ResetPassword,
        exact: true,
      },
    ],
  },
  {
    path: '/',
    component: LayoutAdmin,
    exact: false,
    routes: [
      {
        path: '/',
        component: AdminHome,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_VENTAS,
          ROL_LAYOUT,
        ],
        exact: true,
      },

      {
        path: '/rentabilidad',
        component: Rentability,
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/facturacion',
        component: AdminBilling,
        roles: [ROL_SUPPLIER, ROL_CUSTOMER],
        exact: true,
      },
      {
        path: '/proveedor/operaciones',
        component: SuplierOperations,
        roles: [ROL_SUPPLIER],
        exact: true,
      },
      {
        path: '/cxp/:userType',
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL, ROL_LAYOUT],
        component: CardsBilling,
        exact: true,
      },
      {
        path: '/cxp/facturacion/proveedores',
        component: AdminBilling,
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/cxp/ordenes/proveedores',
        component: PurchaseOrder,
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/facturacion/detalles/documentos/:id',
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: BilllingDocument,
        exact: true,
      },
      {
        path: '/facturacion/pagos/:type/:invoiceId/:folio',
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: Payments,
        exact: true,
      },
      {
        path: '/pagos',
        component: AdminPayment,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones',
        component: AdminClarifications,
        roles: [
          ROL_SUPPLIER,
          ROL_CUSTOMER,
          // ROL_MANAGER,
          // ROL_OPERACIONES,
          // ROL_FINANCIAL,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones/clientes',
        component: ClientClarifications,
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL],
        exact: true,
      },
      {
        path: '/aclaraciones/proveedores',
        component: AdminClarifications,
        roles: [ROL_SUPPLIER, ROL_OPERACIONES, ROL_FINANCIAL],
        exact: true,
      },
      {
        path: '/aclaraciones/detail',
        component: AdminClarificationsDetail,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones/archivos/:idNote',
        component: AdminAddClarificationDocuments,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones/detail/:idAclaracion',
        component: AdminClarificationsDetail,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones/nueva/:idAclaracion',
        component: AdminAddClarifications,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
        ],
        exact: true,
      },
      {
        path: '/aclaraciones/nueva/cp/:idAclaracion',
        component: AdminAddClarificationPayment,
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_CUSTOMER,
        ],
        exact: true,
      },
      {
        path: '/perfil',
        component: AdminProfile,
        roles: ROL_TODOS,
        exact: true,
      },
      {
        path: '/configuracion',
        roles: [ROL_ADMIN],
        component: AdminConfiguration,
        exact: true,
      },
      {
        path: '/configuracion/compañia',
        roles: [ROL_ADMIN],
        component: AdminCompanyData,
        exact: true,
      },
      {
        path: '/configuracion/contacto',
        roles: [ROL_ADMIN],
        component: AdminContact,
        exact: true,
      },
      {
        path: '/configuracion/series',
        roles: [ROL_ADMIN],
        component: AdminSeries,
        exact: true,
      },
      {
        path: '/administracion',
        roles: [ROL_ADMIN, ROL_FINANCIAL, ROL_LAYOUT],
        component: Administration,
        exact: true,
      },
      {
        path: '/administracion/proveedores',
        roles: [ROL_ADMIN, ROL_LAYOUT],
        component: SuplierCatalog,
        exact: true,
      },
      {
        path: '/administracion/usuarios',
        roles: [ROL_ADMIN, ROL_LAYOUT],
        component: UsersCatalog,
        exact: true,
      },
      {
        path: '/administracion/alertas',
        roles: [ROL_ADMIN, ROL_FINANCIAL, ROL_LAYOUT],
        component: AlertsCatalog,
        exact: true,
      },
      {
        path: '/administracion/clientes',
        component: ClientsCatalog,
        roles: [ROL_ADMIN, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/proveedores',
        component: AdminSuppliers,
        roles: [ROL_FINANCIAL, ROL_MANAGER, ROL_ADMIN, ROL_PRICING, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/administracion/proveedores/:iduser',
        component: AdminFinancial,
        roles: [ROL_ADMIN],
        exact: true,
      },
      {
        path: '/ventas',
        component: Sales,
        roles: [ROL_VENTAS, ROL_MANAGER, ROL_ADMIN],
        exact: true,
      },
      {
        path: '/pricing/:pricingType',
        component: Pricing,
        roles: [ROL_PRICING, ROL_MANAGER, ROL_ADMIN, ROL_SUPPLIER, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/pricing/respuestas/rfq/:rfqId/:quoteId',
        component: RFQResponses,
        roles: [ROL_PRICING, ROL_MANAGER, ROL_ADMIN, ROL_SUPPLIER, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/trafico',
        component: Traffic,
        roles: [ROL_PRICING, ROL_MANAGER, ROL_ADMIN, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/catalog',
        component: Catalog,
        roles: [ROL_ADMIN, ROL_LAYOUT],
        exact: true,
      },
      // {
      //   path: '/operaciones',
      //   roles: [ROL_CUSTOMER, ROL_MANAGER, ROL_OPERACIONES],
      //   component: ClientOperation,
      //   exact: true,
      // },
      // {
      //   path: '/operaciones/detalle/:id',
      //   roles: [ROL_CUSTOMER, ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL],
      //   component: ClientOperationDetail,
      //   exact: true,
      // },
      // {
      //   path: '/operaciones/detalles/documentos/:id',
      //   roles: [ROL_CUSTOMER, ROL_MANAGER, ROL_OPERACIONES],
      //   component: ClientOperationDocument,
      //   exact: true,
      // },
      {
        path: '/modulo/:moduleID',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_LAYOUT,
          ROL_ADMIN,
        ],
        component: Modules,
        exact: true,
      },
      {
        path: '/cotizacion',
        roles: [
          ROL_VENTAS,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_CUSTOMER,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: Quote,
        exact: true,
      },
      {
        path: '/cotizacion/nueva',
        roles: [ROL_VENTAS, ROL_MANAGER, ROL_ADMIN, ROL_LAYOUT],
        component: AddQuote,
        exact: true,
      },
      {
        path: '/lineas/:type/:quoteId',
        roles: [
          ROL_VENTAS,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_CUSTOMER,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: LinesQuote,
        exact: true,
      },
      {
        path: '/cotizacion/:quoteId/pdf',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: ViewPdf,
        exact: true,
      },
      {
        path: '/analisis/cotizacion',
        roles: [
          ROL_VENTAS,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_LAYOUT,
        ],
        component: UnUsedQuotes,
        exact: true,
      },
      {
        path: '/analisis/ascenso-descenso/proveedores/:dateParams',
        roles: [
          ROL_VENTAS,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_LAYOUT,
        ],
        component: SupplierPromotion,
        exact: true,
      },
      {
        path: '/analisis/ascenso-descenso/proveedores',
        roles: [
          ROL_VENTAS,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_LAYOUT,
        ],
        component: SupplierPromotion,
        exact: true,
      },
      {
        path: '/analisis/ascenso-descenso/clientes',
        roles: [
          ROL_VENTAS,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_LAYOUT,
        ],
        component: CustomerPromotion,
        exact: true,
      },
      {
        path: '/analisis/ascenso-descenso/clientes/:dateParams',
        roles: [
          ROL_VENTAS,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_LAYOUT,
        ],
        component: CustomerPromotion,
        exact: true,
      },
      {
        path: '/proveedores/contactos/:supplierId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_OPERACIONES,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: SuppliersContacts,
        exact: true,
      },
      {
        path: '/proveedores/patio/:supplierId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_OPERACIONES,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: SuppliersContainerYard,
        exact: true,
      },
      {
        path: '/proveedores/rutas/:supplierId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_OPERACIONES,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: SupplierRoutes,
        exact: true,
      },
      {
        path: '/proveedores/servicios/:supplierId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_ADMIN,
          ROL_PRICING,
          ROL_OPERACIONES,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: SuppliersAdditionalServices,
        exact: true,
      },
      {
        path: '/clientes',
        component: AdminCustomers,
        roles: [
          ROL_FINANCIAL,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_ADMIN,
          ROL_LAYOUT,
        ],
        exact: true,
      },
      {
        path: '/estado/cuentas',
        component: CustomerBalance,
        roles: [ROL_CUSTOMER, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/clientes/contactos/:clientId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_VENTAS,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: CustomerClients,
        exact: true,
      },
      {
        path: '/clientes/rutas/:clientId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_VENTAS,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: RoutesClient,
        exact: true,
      },
      {
        path: '/clientes/documentos/:clientId',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_ADMIN,
          ROL_VENTAS,
          ROL_LAYOUT,
          ROL_FINANCIAL,
        ],
        component: DocumentsClient,
        exact: true,
      },
      {
        path: '/catalogo/clientes/:iduser/:type',
        component: AdminClientFinancial,
        roles: [ROL_ADMIN],
        exact: true,
      },
      {
        path: '/operaciones/',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: Operation,
        exact: true,
      },
      {
        path: '/unidades-disponibles',
        roles: [
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_PRICING,
          ROL_LAYOUT,
        ],
        component: AvailableUnits,
        exact: true,
      },
      {
        path: '/llamadas',
        roles: [
          ROL_OPERACIONES,
          ROL_PRICING,
          ROL_VENTAS,
          ROL_ADMIN,
          ROL_LAYOUT,
        ],
        component: CallLog,
        exact: true,
      },
      {
        path: '/cxc/:userType',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: CardsBilling,
        exact: true,
      },
      {
        path: '/cxc/operaciones/clientes',
        roles: [
          ROL_CUSTOMER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_VENTAS,
          ROL_FINANCIAL,
          ROL_LAYOUT,
        ],
        component: OperationFinancial,
        exact: true,
      },
      {
        path: '/cxc/facturacion/clientes',
        component: ClientBilling,
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_FINANCIAL, ROL_LAYOUT],
        exact: true,
      },
      {
        path: '/cxc/estado/cuentas',
        component: ClientBalance,
        roles: [ROL_FINANCIAL, ROL_LAYOUT, ROL_MANAGER],
        exact: true,
      },
      {
        path: '/operacion/nueva',
        roles: [ROL_MANAGER, ROL_OPERACIONES, ROL_LAYOUT],
        component: AddOperation,
        exact: true,
      },
      {
        path: '/operacion/documentos/:id',
        roles: [
          ROL_SUPPLIER,
          ROL_MANAGER,
          ROL_OPERACIONES,
          ROL_FINANCIAL,
          ROL_VENTAS,
          ROL_LAYOUT,
        ],
        component: OperationDocuments,
        exact: true,
      },
      {
        component: Error404,
      },
    ],
  },
];

export default routes;
